import { useEffect, useState } from 'react';
import { getAccountScope, getSelectedAccountsSubject, getUser, updateAccountContext } from '../../../store/User';
import { Account } from '../../../types';
import { refreshAccountScopedData } from '../../../store/accountScopedData';
import { AccountMultiSelect } from './AccountMultiSelect';
import { userInSkipRoles } from '../../../store/Role';
import { AccountSelectionForm } from '../UserCreation';
import { NAV_RECENT_ACCOUNTS } from '../UserCreation/recentAccounts';
import { useNavigate } from 'react-router-dom';

import { ThemeProvider, createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark'
  }
});

export const AccountDropdown = () => {
  const [selectedAccounts, setSelectedAccounts] = useState<Account[] | undefined>(getAccountScope());
  const user = getUser();
  const navigate = useNavigate();

  const handleAccountSelect = async (accounts: Account[] | null) => {
    await updateAccountContext(accounts || []);
    if (accounts?.length) refreshAccountScopedData();

    setSelectedAccounts(accounts || undefined);
    if (!accounts?.length) navigate('');
  };

  useEffect(() => {
    const acctSub = getSelectedAccountsSubject().subscribe((accts) => {
      if (accts && accts.length) {
        setSelectedAccounts(accts);
      }
    });

    return () => {
      if (acctSub) acctSub.unsubscribe();
    };
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      {!userInSkipRoles(user.roles.map((r) => r.name)) && (
        <AccountMultiSelect
          accounts={user.accounts}
          handleAccountSelect={handleAccountSelect}
        />
      )}
      {selectedAccounts && userInSkipRoles(user.roles.map((r) => r.name)) && (
        <AccountSelectionForm
          accounts={user.accounts}
          setSelectedAccount={(v) => handleAccountSelect(v ? [v] : null)}
          selectedAccount={selectedAccounts?.[0] || null}
          styles="flex items-center w-72"
          showLabel={false}
          openOnFocus
          searchLayout
          recentAccountsStore={NAV_RECENT_ACCOUNTS}
          totalAccountCount={user.accounts_count}
          inputStyles="h-[1.75rem] bg-nav-100"
          styleOverride={{
            '.MuiInputBase-input': {
              height: '0.75rem'
            },
            'MuiFormControl-root': {
              height: 'unset'
            }
          }}
        />
      )}
    </ThemeProvider>
  );
};
